<template>
  <div id="publishing-publishing">
    <div class="ipub-h1 mar-b-20 line-h-40 relative">
      Publication
      <div class="ipub-p1 right-option">
        <ipub-button v-if="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.ADD')"
                     type="primary"
                     icon="iconAdd"
                     @click="add">
          Add New Article
        </ipub-button>
        <ipub-upload v-if="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.IMPORT')"
                     @change="imp"
                     style="margin: 0 20px">
          <ipub-button type="primary">
            Import
          </ipub-button>
        </ipub-upload>
        <ipub-button v-if="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.EXPORT')"
                     type="primary"
                     @click="exp">
          Export
        </ipub-button>
        <!-- <ipub-button plain
                     type="primary"
                     @click="publish">
          Publish
        </ipub-button> -->
      </div>
    </div>
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="12">
          <ipub-col :span="2">
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         @change="changeJournal"
                         :options="journalList" />
          </ipub-col>
          <ipub-col :span="10">
            <site-search-group class="mar-b-16"
                               v-model.trim="params.search"
                               placeholder="Title / DOI / Manuscript No. / Author / Keywords"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <div class="mar-b-40"
             v-if="showAdv">
          <span class="line-h-40 ipub-p2 fw-bd">Volume & Issue</span>
          <ipub-select class="mar-l-12"
                       placeholder="Select Volume"
                       v-model="params.volumeId"
                       optionTitle="code"
                       style="width:200px"
                       @change="getIssueCode"
                       :options="volumeList" />
          <ipub-select class="mar-l-12"
                       placeholder="Select Issue"
                       optionTitle="code"
                       style="width:200px"
                       @change="getList()"
                       :disabled="!params.volumeId"
                       v-model="params.issueId"
                       :options="issueList" />
        </div>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>

    <div class="ipub-list-tab">
      <a @click="changeStatus('')"
         :class="['ipub-list-tab--status',params.status===''?'active':'']">All ({{countObj.ALL}})</a>
      <a @click="changeStatus('UNPUBLISHED')"
         :class="['ipub-list-tab--status ',params.status==='UNPUBLISHED'?'active':'']">Pending Online ({{countObj.UNPUBLISHED}})</a>
      <a @click="changeStatus('PUBLISHED')"
         :class="['ipub-list-tab--status ',params.status==='PUBLISHED'?'active':'']">Online ({{countObj.PUBLISHED}})</a>
      <a @click="changeStatus('RETRACTION')"
         :class="['ipub-list-tab--status ',params.status==='RETRACTION'?'active':'']">Retraction ({{countObj.RETRACTION}})</a>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  fixed
                  :empty="{icon:'iconSI_article'}"
                  :emptyText="emptyText[params.status||'all']"
                  @order="onOrderChanage"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:operator="{text}">
          <template v-if="text">{{text.firstName}} {{text.lastName}}</template>
          <template v-else>--</template>
        </template>
        <template v-slot:doied="{text,record}">
          <div class="flex">
            <ipub-label size="small"
                        type="success"
                        style="width:100px"
                        cover
                        v-if="text===true">Registered</ipub-label>
            <ipub-label size="small"
                        type="danger"
                        style="width:100px"
                        cover
                        v-else>Unregistered</ipub-label>
            <ipub-tooltip v-show="text===true && user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.ROLLBACK_DOI')">
              <div slot="title">Rollback</div>
              <ipub-icon type="iconundo"
                         @click="updateDOI(record)"
                         style="font-size:16px"
                         class="mar-l-12 ipub-cursor-pointer link-color" />
            </ipub-tooltip>
            <ipub-tooltip v-show="!text && user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.OFFLINE_REGISTER_DOI')">
              <div slot="title">Offline Registration</div>
              <ipub-icon type="iconRegisterDOI"
                         @click="updateDOI(record,'offline')"
                         style="font-size:16px"
                         class="mar-l-12 ipub-cursor-pointer link-color" />
            </ipub-tooltip>

          </div>

        </template>
        <template v-slot:publish="{text}">
          <ipub-label size="small"
                      type="success"
                      style="width:80px"
                      cover
                      v-if="text === 'PUBLISHED'">Published</ipub-label>
          <ipub-label size="small"
                      type="danger"
                      style="width:80px"
                      cover
                      v-else-if="text === 'UNPUBLISHED'">Pending</ipub-label>
          <ipub-label size="small"
                      type="default"
                      style="width:80px"
                      cover
                      v-else-if="text === 'RETRACTION'">Retraction</ipub-label>
        </template>
        <template v-slot:baiduStatus="{record}">
          <ipub-label size="small"
                      type="success"
                      style="width:80px"
                      cover
                      v-if="record.baiduScholar && record.baiduScholar.status === 'OK'">Successed</ipub-label>
          <!-- <div class="ipub-table-status-show ipub-table-status-show--active"
               v-if="record.baiduScholar && record.baiduScholar.status === 'OK'"></div> -->
          <template v-else>
            <ipub-label size="small"
                        style="width:80px"
                        cover
                        type="danger">Failed</ipub-label>
            <ipub-tooltip>
              <div slot="title">Upload Again</div>
              <ipub-icon type="iconrefresh"
                         @click="refreshBaidu(record.id)"
                         style="font-size:16px"
                         class="link-color mar-l-12 ipub-cursor-pointer" />
            </ipub-tooltip>
          </template>
        </template>
        <template v-slot:code="{ text, record }">
          <font>{{text}}</font>
          <ipub-label v-if="record.ebed"
                      size="small"
                      style="margin-left: 4px;padding:0 5px"
                      type="link">
            EB
          </ipub-label>
          <ipub-label v-if="record.rbed"
                      size="small"
                      style="margin-left: 4px;padding:0 5px"
                      type="link">
            RB
          </ipub-label>
          <ipub-label v-if="record.geed"
                      size="small"
                      style="margin-left: 4px;padding:0 5px"
                      type="link">
            GE
          </ipub-label>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip placement="bottomLeft"
                        action="click"
                        type="light"
                        class="border-right ">
            <div slot="title"
                 class="hover-action-content">
              <div class="ipub-cursor-pointer">
                <a @click="openWebsite(record)"
                   v-if="record.xmlFile">
                  <ipub-icon type="iconhtml" />
                  Preview HTML
                </a>
                <font class="disabled-icon"
                      v-else>
                  <ipub-icon type="iconhtml" />
                  Preview HTML
                </font>
              </div>
              <div class="ipub-cursor-pointer">
                <a v-if="record.xmlFile"
                   @click="openPdf(record)">
                  <ipub-icon type="iconXML" />
                  Preview XML
                </a>
                <font class="disabled-icon"
                      v-else>
                  <ipub-icon type="iconXML" />
                  Preview XML
                </font>
              </div>
              <div class="ipub-cursor-pointer">
                <a v-if="record.pdfFile"
                   @click="openPdf(record,'pdf')">
                  <ipub-icon type="iconPDF1" />
                  Preview PDF
                </a>
                <font class="disabled-icon"
                      v-else>
                  <ipub-icon type="iconPDF1" />
                  Preview PDF
                </font>
              </div>
            </div>
            <ipub-icon type="iconViewDetails" />
          </ipub-tooltip>
          <template>
            <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.EDIT')"
                          v-if="!((record.status === 'RETRACTION' || (record.status === 'PUBLISHED' && record.atype && record.atype.type !== 'RETRACTION' && record.retractionCode) && record.atype && record.atype.type !== 'RETRACTION'))"
                          class="border-right">
              <div slot="title">Edit</div>
              <ipub-icon type="iconEdit"
                         @click="edit(record)" />
            </ipub-tooltip>
            <ipub-icon v-else
                       class="disabled-icon"
                       type="iconEdit" />
          </template>
          <template v-if="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.PUBLISH')">
            <ipub-tooltip v-if="record.status === 'UNPUBLISHED'"
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record, 'PUBLISHED')" />
            </ipub-tooltip>
            <ipub-tooltip v-else-if="record.status === 'PUBLISHED' && !(record.atype && record.atype.type !== 'RETRACTION' && record.retractionCode)"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record, 'UNPUBLISHED')" />
            </ipub-tooltip>
            <ipub-icon v-else
                       type="iconDisable"
                       class="disabled-icon" />
          </template>
          <ipub-tooltip placement="bottomRight"
                        action="click"
                        type="light"
                        v-if="user.codeList&&(user.codeList.includes('WEBSITE.PUBLISHING.WITHDRAW')||user.codeList.includes('WEBSITE.PUBLISHING.DELETE'))">
            <div class="ipub-cursor-pointer hover-action-content"
                 slot="title">
              <template v-if="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.WITHDRAW')">
                <div v-if="record.status === 'RETRACTION'"
                     @click="able(record, 'PUBLISHED')">
                  <ipub-icon style="font-size:16px"
                             type="iconundo" />Cancel retraction
                </div>
                <div @click="able(record, 'RETRACTION')"
                     v-else-if="record.status === 'PUBLISHED' && record.atype && record.atype.type!=='RETRACTION'">
                  <ipub-icon type="icona-BacktoAuthor"
                             style="font-size:16px" />Retractions
                </div>
              </template>
              <div @click="updateDOI(record,true)"
                   v-show="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.REGISTER_DOI')">
                <ipub-icon type="iconRegisterDOI"
                           style="font-size:16px" />Register DOI
              </div>
              <div @click="del(record)"
                   v-show="user.codeList&&user.codeList.includes('WEBSITE.PUBLISHING.DELETE')">
                <ipub-icon type="iconDelete"
                           style="font-size:16px" />
                Delete
              </div>
            </div>
            <ipub-icon type="iconMore" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <tipInfo-dialog :isVisable="isVisable"
                    :inputData="inputData"
                    @confirm="publishAfter"
                    @cancel="cancel"></tipInfo-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
